import React,{useState, useEffect} from 'react';

import Letra from './Letra';

import { PALETA, PALETA_ACTIVA ,BOTON_COLOR } from '../config/general';


const Board = ({ sopa, exportPalabrasBoard }) => {

    const boardStyle = {
        height: '95vh',
        aspectRatio: '1 / 1',
        display: 'grid',
        gridTemplate: 'repeat(12, 1fr) / repeat(12, 1fr)'
    }

    const [sopaLetras, setSopaLetras] = useState([]);
    const [board, setBoard] = useState([]);
    const [boardEncontradas, setBoardEncontradas] = useState([]);
    const [sopaPalabras, setSopaPalabras] = useState([]);
    const [sopaPalabrasWithoutSpaces, setSopaPalabrasWithoutSpaces] = useState([]);
    const [turno, setTurno] = useState(0);
    const [letrasJugadas, setLetrasJugadas] = useState([]);
    const [idsJugados, setIdsJugados] = useState([]);
    const [idsEncontrados, setIdsEncontrados] = useState([]);
    const [direccion, setDireccion] = useState(0);

    useEffect(()=> {
        setSopaLetras(sopa.letras.split(','));
        setSopaPalabras(sopa.palabras.split(','));
      }, [sopa.letras, sopa.palabras])

    useEffect(()=> {
      setBoard(Array(sopaLetras.length).fill(BOTON_COLOR));
      setBoardEncontradas(Array(sopaLetras.length).fill(BOTON_COLOR));
    }, [sopaLetras])

    useEffect(()=> {
      //Crea una version de las palabras sin espacio para poder comparar
      const stringWithoutSpaces = []
      for (const string of sopaPalabras){
        stringWithoutSpaces.push(string.replace(/\s/g, ''));
      }
      setSopaPalabrasWithoutSpaces(stringWithoutSpaces)
      exportPalabrasBoard(sopaPalabras);

      //revisa si el juego se termina para limpiar el board para el proximo juego
      if (sopaPalabras.length === 0){
        setTurno(0);
        setIdsEncontrados([]);
      }
    }, [sopaPalabras,exportPalabrasBoard]);


    useEffect(()=> {
        // Cada vez que se actualiza letrasJugadas, se verifica si se encontro una palabra
        //console.log(letrasJugadas);
        const palabra = letrasJugadas.join('');
        const index = sopaPalabrasWithoutSpaces.indexOf(palabra);

        if (index !== -1) {
            //console.log(`Palabra encontrada`);
            // Cambia el color de las letras encontradas
            const boardCopy = [...board];
              for(const id of idsJugados){
              //resolver cuando la letra ya estaba jugada
              boardCopy[id] = PALETA_ACTIVA[turno];
            }
            setBoard(boardCopy);
            setBoardEncontradas(boardCopy)
            
            //guarda los ids encontrados en el array 
            const encontrados = [...idsEncontrados]
            let encontradosCopy = encontrados.concat(idsJugados);
            setIdsEncontrados(encontradosCopy);

            //quita la palabra de sopaPalabra
            const palabraIndex = sopaPalabrasWithoutSpaces.indexOf(palabra);
            const sopaPalabrasCopy = [...sopaPalabras];
            if (palabraIndex !== -1 ){
              sopaPalabrasCopy.splice(palabraIndex, 1);
            }
            else{
              console.error('La palabra no se encuentra en el pool:', palabra);
            }
            setSopaPalabras(sopaPalabrasCopy);

            //resetea las propiedades
            setLetrasJugadas([]);
            setIdsJugados([]);
            setDireccion(0);
            setTurno(turno + 1);
          } 
          //else {
            //console.log(`Palabra no encontrada`);
          //}
          
          // deshabilita el warning de dependencias en este caso,
          // porque explicitamente necesita correr solo si
          // letrasJugadas cambia.

          // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [letrasJugadas]);

    const limpiarTabla = () => {
      setBoard(boardEncontradas);
      setLetrasJugadas([]);
      setIdsJugados([]);
      setDireccion(0);
    }

    const handleLetraClick = ( letra, id ) => {
        // actualizar board con color
        const boardCopy = [...board];
        boardCopy[id] = PALETA[turno];
        setBoard(boardCopy);

        // actualiza las letras jugadas
        const updateLetrasJugadas = [...letrasJugadas, letra];
        setLetrasJugadas(updateLetrasJugadas);

        //actualiza los ids jugados
        const updateIdsJugados = [...idsJugados, id];
        setIdsJugados(updateIdsJugados);
        //console.log(id, idsJugados[idsJugados.length - 1] + 1);

        if( direccion === 0){
          //reconoce la direccion de la jugada
          // si presiono el mismo boton, reseteo
          if(id === idsJugados[idsJugados.length - 1]){
            limpiarTabla();
            // console.log("vuelve a apretar el mismo boton")
          }
          if(id > idsJugados[idsJugados.length - 1] + 1 && id < idsJugados[idsJugados.length - 1] + 11){
            limpiarTabla();
            // console.log("mayor de 2 a 10")
          }
          if(id < idsJugados[idsJugados.length - 1] - 1 && id > idsJugados[idsJugados.length - 1] - 11){
            limpiarTabla();
            // console.log("menor de 2 a 10")
          }
          if(id < idsJugados[idsJugados.length - 1] - 13 || id > idsJugados[idsJugados.length - 1] + 13){
            limpiarTabla();
            // console.log("mayor o menor de 13")
          }
          //adelante
          if(id === idsJugados[idsJugados.length - 1] + 1){
            setDireccion(1);
          }
          //atras
          else if (id === idsJugados[idsJugados.length - 1] - 1){
            setDireccion(-1);
          }
          //arriba
          else if (id === idsJugados[idsJugados.length - 1] - 12){
            setDireccion(-12);
          }
          //abajo
          else if (id === idsJugados[idsJugados.length - 1] + 12){
            setDireccion(12);
          }
          //diagonal adelante arriba
          else if (id === idsJugados[idsJugados.length - 1] - 11){
            setDireccion(-11);
          }
          //diagonal adelante abajo
          else if (id === idsJugados[idsJugados.length - 1] + 13){
            setDireccion(13);
          }
          //diagonal atras arriba
          else if (id === idsJugados[idsJugados.length - 1] -13){
            setDireccion(-13);
          }
          //diagonal atras abajo
          else if (id === idsJugados[idsJugados.length - 1] + 11){
            setDireccion(11);
          }
        }
        else{
          if(id === idsJugados[idsJugados.length - 1] + direccion){
            //console.log("OK");
          }
          else{
            //console.log("error limpiar tabla");
            limpiarTabla();
          }
        }
      };
    

  return (
    <div className='sopa-board' style={ boardStyle }>
        {sopaLetras.map((letra, index) => (
            <Letra key={index} letra={ letra } id={ index } jugarLetra={ handleLetraClick } color={ board[index] } />
        ))}
    </div>
  )
}

export default Board